const fullName = ({first_name, last_name}) => [first_name, last_name].filter(v => v).join(' ');

const joinNames = (names) => names.length < 2
    ? names.join('')
    : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;

// A changed start or end removes every technician on the block: that is the database trigger
// clear_inspection_workers_after_schedule_change. The form only sends dates that changed.
export const saveChangesSchedule = (changes) => 'scheduled_date' in changes || 'scheduled_end_date' in changes;

export const technicianRemovalWarning = (technicians) => {
    if(technicians.length === 0) {
        return null;
    }
    const one = technicians.length === 1;
    return {
        title: one ? 'This save removes the assigned technician' : 'This save removes the assigned technicians',
        content: `Changing the start or end date or time removes ${one ? '' : `${technicians.length} technicians: `}${joinNames(technicians.map(fullName))} from this time block. They will need to be re-assigned after saving.`,
        okText: one ? 'Save and remove technician' : 'Save and remove technicians',
        okType: 'danger',
    };
};
